module.exports = __webpack_public_path__ + "static/media/bts_boots_170812_006_small.ea0f1829.jpg";